import { useRef, useState, useCallback, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SelectOverlay from 'components/Inputs/SelectOverlay';
import MultiSelect from 'components/Inputs/MultiSelect';
import ApplySelectButton from 'components/Inputs/Select/ApplyButton';
import ClearSelectButton from 'components/Inputs/Select/ClearButton';
import SelectAllButton from 'components/Inputs/MultiSelect/SelectAllButton';
import IconAdornment from 'components/Inputs/Adornments/IconAdornment';
import {
  Entities,
  useSelectTypeaheadWithScroll,
} from 'components/Inputs/Select/hooks';

export const RoleMultiSelect = ({
  onChange,
  teamMemberCount = 0,
  trigger,
  isShowing,
  setIsShowing,
  rolesCount,
  ...others
}) => {
  const { t } = useTranslation();

  const [value, setValue] = useState([]);
  const selectRef = useRef();

  useEffect(() => {
    if (!rolesCount) {
      setValue([]);
    }
  }, [rolesCount]);

  const chosenValueIds = useMemo(
    () => value.map(({ value }) => value),
    [value]
  );

  const [selectProps] = useSelectTypeaheadWithScroll({
    selectRef,
    entity: Entities.Role,
    chosenValueIds,
    alwaysOpen: isShowing,
  });

  const handleApply = useCallback(() => {
    onChange((prev) => ({
      ...prev,
      roleIds: value.map((el) => el.value).join(','),
      rolesCount: value.length,
    }));
    setIsShowing(false);
  }, [value, onChange, setIsShowing]);

  const handleClear = useCallback(() => {
    setValue([]);
  }, []);

  return (
    <>
      <SelectOverlay
        show={isShowing}
        target={trigger.current}
        onHide={handleApply}
        placement="bottom-end"
        popperConfig={{}}
      >
        <MultiSelect
          value={value}
          onChange={setValue}
          placeholder={t('Find Roles')}
          menuTopButton={<SelectAllButton />}
          menuLeftButton={<ClearSelectButton onClick={handleClear} />}
          menuRightButton={<ApplySelectButton onClick={handleApply} />}
          endAdornment={<IconAdornment icon="search" />}
          {...selectProps}
          {...others}
          ref={selectRef}
        />
      </SelectOverlay>
    </>
  );
};
